import { useSegmentBaseUrl } from 'src/pages/Settings/memberships/hooks/use-segment-base-url';

/** Undefined until the page has a slug, i.e. before its first save. */
export const useLandingPageLiveUrl = (
  partnerId: number | null,
  brandId: string | undefined,
  slug: string,
): string | undefined => {
  const baseUrl = useSegmentBaseUrl(partnerId, brandId);

  return baseUrl && slug ? `${baseUrl}/${slug}` : undefined;
};
